import React from "react";
import { Box } from "@mui/material";
import moment from "moment-timezone";
import { removeIdTag } from "./analyzeUtils";

export default function ConversationItem({ conversation }) {
  const zone_name = moment.tz.guess();
  const timezone = moment.tz(zone_name).zoneAbbr();
  const _author = removeIdTag(conversation.author);

  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Box sx={styles.infoContainer}>
        <Box sx={styles.author}>{_author}</Box>
        <Box sx={styles.dateCreated}>
          {`${moment(conversation.createdDate).format("MMM D, YYYY hh:mm a z")} ${timezone}`}
        </Box>
      </Box>

      <Box sx={{ padding: "0px 20px" }}>
        <Box sx={styles.messageContainer}>{conversation.text}</Box>
      </Box>
    </Box>
  );
}

export const styles = {
  infoContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0px 20px 4px",
  },
  author: {
    fontFamily: "FustatMedium",
    fontSize: "14px",
  },
  dateCreated: {
    color: "#6E6E6E",
    fontWeight: 400,
    fontSize: "13px",
    fontFamily: "FustatRegular",
  },
  messageContainer: {
    lineHeight: "140%",
    fontFamily: "LarsseitRegular",
    fontSize: "15px",
    color: "#0C2728",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    blockquote: {
      border: "1px solid #DCE2E3",
      borderRadius: "3px",
    },
  },
};
